"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationMoney = function IllustrationMoney() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "65",
    height: "65",
    fill: "none",
    viewBox: "0 0 65 65"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "65",
    height: "65",
    fill: "#F3F1F5",
    rx: "22"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "21",
    height: "5",
    x: "15.737",
    y: "13",
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    rx: "1"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "21",
    height: "5",
    x: "15.737",
    y: "18",
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    rx: "1"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "21",
    height: "5",
    x: "15.737",
    y: "23",
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    rx: "1"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "21",
    height: "5",
    x: "15.737",
    y: "28",
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    rx: "1"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "21",
    height: "5",
    x: "15.737",
    y: "33",
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    rx: "1"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "39",
    cy: "39",
    r: "12",
    fill: "#F3F1F5",
    stroke: "#6F558A",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "39",
    cy: "39",
    r: "8",
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "24.5",
    cy: "43",
    fill: "#F3F1F5",
    stroke: "#6F558A",
    strokeWidth: "1.5",
    rx: "9.5",
    ry: "9"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M40.683 36.343a3.084 3.084 0 100 5.482"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    d: "M39.612 38.398h-3.769M39.612 40.111h-3.769"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26.846 40.343a3.088 3.088 0 100 5.49"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    d: "M25.774 42.401H22M25.774 44.117H22"
  }));
};

var _default = IllustrationMoney;
exports.default = _default;